import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const ChevronUpIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    fill="none"
    height="24"
    optimizationId="tama-chevron-up"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83893 14.6891L12.0054 10.5645L16.1718 14.6891C16.5906 15.1036 17.2671 15.1036 17.6859 14.6891C18.1047 14.2745 18.1047 13.6048 17.6859 13.1902L12.757 8.31093C12.3383 7.89636 11.6617 7.89636 11.243 8.31093L6.31409 13.1902C5.8953 13.6048 5.8953 14.2745 6.31409 14.6891C6.73289 15.093 7.42013 15.1036 7.83893 14.6891Z"
      fill="currentColor"
    />
  </Svg>
));

ChevronUpIcon.displayName = 'ChevronUpIcon';
